"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkHealth = void 0;
const shared_1 = require("@getgreenline/shared");
const convertFromXmlToJson_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertFromXmlToJson");
const convertHealthCheckFromJsonToXml_1 = require("../../../models/worldpay/system/helpers/convertHealthCheckFromJsonToXml");
const findNestedObjectValue_1 = require("../../../models/worldpay/system/helpers/findNestedObjectValue");
const checkHealth = async (params) => {
    const xml = (0, convertHealthCheckFromJsonToXml_1.convertHealthCheckFromJsonToXml)(params);
    const res = await shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data);
    const expressResponseCode = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'ExpressResponseCode');
    const expressResponseMessage = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'ExpressResponseMessage');
    if (expressResponseCode === undefined)
        throw Error('ExpressResponseCode not found in response');
    return {
        expressResponseCode,
        expressResponseMessage,
        response: json,
    };
};
exports.checkHealth = checkHealth;
//# sourceMappingURL=WorldpaySystemAPI.js.map